const MAX_FILE_UPLOAD_COUNT = 30;
export function useMaxFileUpload() {
    return MAX_FILE_UPLOAD_COUNT;
}
//# sourceMappingURL=useMaxFileUpload.js.map